/* MatchHeight ====================== */
function setbg() {
  $(".setbg").each(function () {
    var theBg = $(this).find(".bg-img").attr("src");
    $(this).css("background-image", "url(" + theBg + ")");
    $(this).find("img.bg-img").hide();
  });
}
$(window).scroll(function(){
    if ($(this).scrollTop() > 10) {
       $('body').addClass('scroll');
    } else {
       $('body').removeClass('scroll');
    }
});
$(document).mousemove(function (e) {
  mY = e.clientY; mouseOffset = 0; extraOffset = 0;
  $(".cursor").eq(0).css({ left: e.pageX, top: e.pageY + (mouseOffset - extraOffset) });
  setTimeout(function () {
    $(".cursor").eq(1).css({ left: e.pageX, top: e.pageY + (mouseOffset - extraOffset) });
  }, 80);
});

$(document).ready(function () {
  var wh = $(window).height();
  var main_header = $(".main-header").outerHeight();

  function checkWidth() {
    var windowSize = $(window).innerWidth();
    if (windowSize < 768) {
      //$("#pills-tab").tabCollapse();
    }
  }

  function innerHeroH() {
    $(".inner-page-image").css({ height: wh - main_header });
    $(".full-banner").css({ height: wh });
  }

  checkWidth();
  innerHeroH();

   if($('.wrap-compare-inner-mobile').length){
     $('.wrap-compare-inner-mobile').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       fade: true,
       autoplay: true,
       autoplaySpeed: 3000,
     });    
   }
   if($('.slider_circle').length){
     $('.slider_circle').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       fade: false,
       dots: true,
       autoplay: true,
       autoplaySpeed: 3000,
       responsive: [{ breakpoint: 769, settings: { slidesToShow: 3, slidesToScroll: 1 } },{ breakpoint: 560, settings: { slidesToShow: 1, slidesToScroll: 1 } }],
     });    
   }  

   if($('.cls-columns-cases-testimonials').length){
     $('.cls-columns-cases-testimonials').slick({
       slidesToShow: 3,
       slidesToScroll: 1,
       arrows: true,
       fade: false,
       dots: true,
       autoplay: true,
       autoplaySpeed: 3000,
       responsive: [{ breakpoint: 769, settings: { slidesToShow: 1, slidesToScroll: 1 } },{ breakpoint: 560, settings: { slidesToShow: 1, slidesToScroll: 1 } }],
     });    
   }
  
  $('.wrap-accordion-style').click(function() {    
    $(this).siblings().removeClass('active');
    $(this).find('.accordion-style-footer').slideToggle();
    $(this).siblings().find('.accordion-style-footer').slideUp();
    $(this).hasClass('active') ? $(this).removeClass('active') :  $(this).addClass('active');
  });  
  
  if($('.plots').length){
    $('.client-growth-stories').css('opacity', 1)
    $('.plots').owlCarousel({
        items:5,
        margin: 0,
        loop: false,
        rewind: true,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        autoplay: true,
        autoplayHoverPause:true,
        autoplayTimeout:4500,
        autoplaySpeed:350,
        autoHeight: false,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        transitionStyle: 'fade',
        responsive: {
          0: {
            items: 1
          }
        }
    });   
  }  
 
  if($('.case-study-carousel').length){
    $('.case-study-carousel').css('opacity', 1)    
    $('.case-study-carousel').owlCarousel({
        items:1,
        lazyLoad:true,
        loop:true,
        autoplay:true,
        autoplayHoverPause:true,
        autoplayTimeout:9000,
        margin: 0,
        nav: true,
        dots: true,
        autoHeight: false,
        center: true,
        responsive: {
          0:{items:1.2, margin:18,},
          400:{items:1.2, margin:20,},
        }
    }); 
  }
  
  if($('.stages-slider-wrap').length){
   $('.stages-slider-wrap').slick({
     slidesToShow: 1,
     infinite: true,
     arrows: true,
     dots: true,
      customPaging: function(slider,index) {
                  return '<span>' + "0" + (index + 1) + ' /</span> ' + '0' + slider.slideCount;
              }
   });  
  }  
  
  if ($( window ).width() < 810 ) {
   if($('.solvex-process-slider').length){
     $('.solvex-process-slider').slick({
       infinite: false,
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       fade: false,
     }); 
   }
  }  
  if ($( window ).width() > 768 ) {
  if($('.cls-columns-portfolio-tabs .tabs').length){
   $('.cls-columns-portfolio-tabs .tabs').slick({
     slidesToShow: 4,
     slidesToScroll: 4,
     arrows: true,
     fade: false,
     dots: false,
     autoplay: false,
     autoplaySpeed: 3000,
       responsive: [{ breakpoint: 769, settings: { arrows: false,slidesToShow: 1, slidesToScroll: 1 } },{ breakpoint: 560, settings: { arrows: false,slidesToShow: 1, slidesToScroll: 1 } }]
   });  
  } 
  }
  
  if($('.special-mobile').length){
   $('.special-mobile').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: true,
     fade: false,
     dots: true,
     autoplay: true,
     autoplaySpeed: 3000,
   });  
  }  

  if($('.cls-cases-studies').length){
   $('.cls-cases-studies').slick({
     slidesToShow: 2.02,
     slidesToScroll: 1,
     arrows: false,
     fade: false,
     dots: false,
     autoplay: true,
     autoplaySpeed: 3000,
       responsive: [{ breakpoint: 769, settings: { slidesToShow: 1.02, slidesToScroll: 1 } },{ breakpoint: 560, settings: { slidesToShow: 1.02, slidesToScroll: 1 } }]
   });  
  }  
  
    if($('.about_stats_slider1').length){
        $('.about_stats_slider1').slick({
            centerMode: true,
            autoplay: true,
            arrows: false,
            centerPadding: '380px',
            slidesToShow: 1,
            swipe:true,
            swipeToScroll:1,
            variableWidth: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                  }
                }
            ]
        });
    }
    if($('.about_stats_slider2').length){
        $('.about_stats_slider2').slick({
            centerMode: true,
            autoplay: true,
            arrows: false,
            centerPadding: '380px',
            slidesToShow: 1,
            speed:2000,
            autoplaySpeed: 2000,
            swipe:true,
            swipeToScroll:1,
            variableWidth: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                  }
                }
            ]
        });
    }
  
  
   if($('.solvex-slider-list').length){
      $(".solvex-slider-list").slick({
        dots: false,
        speed: 700,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        touchThreshold: 100,
        responsive: [
          {
            // tablet
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            // mobile portrait
            breakpoint: 479,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      $(".slider-prev").click(function () {
        $("#slider-id").slick("slickPrev");
      });

      $(".slider-next").click(function () {
        $("#slider-id").slick("slickNext");
      });  
    }  
          
    if($('.cls-slider-images').length){
     $('.cls-slider-images').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: true,
       fade: false,
       dots: true,
       autoplay: true,
       autoplaySpeed: 3000,
     });  
    }    
          
    if($('#tp-widget-reviews').length){
     $('#tp-widget-reviews').slick({
       slidesToShow: 3,
       slidesToScroll: 1,
       arrows: true,
       fade: false,
       dots: true,
       autoplay: true,
       autoplaySpeed: 3000,
       responsive: [{ breakpoint: 769, settings: { slidesToShow: 1, slidesToScroll: 1 } },{ breakpoint: 560, settings: { slidesToShow: 1, slidesToScroll: 1 } }]
     });  
    }

    if($('.screenshots-section-row').length){
     $('.screenshots-section-row').slick({
       slidesToShow: 3,
       slidesToScroll: 1,
       arrows: true,
       fade: false,
       dots: true,
       autoplay: true,
       autoplaySpeed: 3000,
       responsive: [{ breakpoint: 9999, settings: "unslick" },{ breakpoint: 769, settings: { slidesToShow: 1, slidesToScroll: 1 } },{ breakpoint: 560, settings: { slidesToShow: 1, slidesToScroll: 1 } }]
     });  
    }

  
  
    if($('._form-title').length){
          if ($('._form-title').text() == 'Where should i send the link to the training video?' ) {
			setInterval(function () { $('._form-title').text('Where should i send the link?') }, 1000);
          }
    }      
          
    $(".block_6c03d1c1-f885-4238-8e5e-ff7fe92f4459, .block_4369945e-0856-4939-aa36-42d105b85528, .block_ae29fe10-4e02-41f2-8857-d1f4db5b0a48, .block_d039119f-ccf3-4860-9501-b8b9c027a1d9, .block_d039119f-ccf3-4860-9501-b8b9c027a1d9, .block_d039119f-ccf3-4860-9501-b8b9c027a1d9").click(function(){
		$(".wrap-form-activehosted").show();
//         $("<div class='btn-close' onclick='closeActiveHosted()'><span class='icon-close'></span></div>").insertBefore("._close");
        return false;
    });
    
    $("#shopify-section-survey-content .element-wrap-button").click(function(){
		$("#shopify-section-survey-content").fadeOut('1600');
        $("#shopify-section-survey").fadeIn('1600');
        return false;
    });  
    $(".block_10c310c6-6be6-499a-9e09-1447777c2eb0").click(function(){
        $('.element-tab-hide').slideToggle();
        return false;
    });
          
  $(".bg-adver").hover(function() {
    $('.img-adver').removeClass("adver-active");
    $(this).parent().addClass("adver-active");
    var target = $(this).attr("data-id");
    $(".inner-advertising-content").removeClass("adver-content-active");
    $(".adver-" + target).addClass("adver-content-active");
  });   
  
  $('.samples-desktop .tablink').click(function() {    
    var id = $(this).attr('data-tablink');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('.content-samples .element-item-subtitle').hide();
    $('.content-samples .content-samples-'+id).show();
  });  
  
  $('.samples-mobile .inner-tablink').click(function() {    
    $(this).siblings().find('.tablink').removeClass('active');
    $(this).find('.element-item-subtitle').slideToggle();
    $(this).siblings().find('.element-item-subtitle').slideUp();
    $(this).find('.tablink').hasClass('active') ? $(this).find('.tablink').removeClass('active') :  $(this).find('.tablink').addClass('active');
  });

  $('.tabbing').on('click',function () {
      $(this).siblings().removeClass('current');
      $(this).addClass('current');
      var target = $(this).attr('data-targetit');
      $('.tabs').removeClass('current');
      $('.'+target).addClass('current');

  });  
  
});

$(".hm-navigation .nav-pills .nav-item a").on("click", function (e) {
  leftpartHeight();
});

// Mega Menu:
let _mega_menu = $("[data-mega-menu]");
let _mega_scroll = $("[data-mega-scroll]");
let _mega_sub = $("[data-mega-sub]");
let _mega_link = $("[data-mega-link]");
let _win_desktop = $(window).width() > 1025;

function setScroll() {
  if (_mega_scroll.length) {
    _mega_scroll.each(function () {
      let that = $(this);
      let _top = offsetTop(that);
      that.css({ "max-height": "calc(100vh - " + _top + "px)" });
    });
  }
}
setScroll();
if (_mega_menu.length) {
  //_mega_menu.prependTo('body');
}
function setModalHeight() {
  let heightWithoutScrollbar = $(window).innerHeight();
  if (_mega_menu.length) {
    _mega_menu.css({ height: heightWithoutScrollbar });
  }
}
setModalHeight();
$(window).on("resize", function () {
  setModalHeight();
  setScroll();
});

function clearMegaTab() {
  $("[data-mega-tab]").removeClass("active");
  $("[data-mega-tab-content]").removeClass("opened");
}

if (_mega_link.length) {
  _mega_link.each(function (i) {
    let that = $(this);
    that.attr("data-mega-link", i);
    if (i === 0 && _win_desktop) {
      that.addClass("active");
    }
  });
}
if (_mega_sub.length) {
  _mega_sub.each(function (i) {
    let that = $(this);
    that.attr("data-mega-sub", i);
    if (i === 0 && _win_desktop) {
      that.addClass("opened");
    }
    if (i === 3 && _win_desktop) {
      that.find(".mega-menu__grid").addClass("grid-2-2");
    }
  });
}
let _menu_item = $(".main-header .navbar-nav .nav-item");
if (_menu_item.length) {
  _menu_item.each(function () {
    if ($(this).hasClass("menu-item-has-children")) {
      $(this).prepend('<i class="menu-icon"/>');
      $(this).find(">a, >i").wrapAll("<span />");
    }
  });
}
$(".nav-item.menu-item-has-children > span").on("click", function (e) {
  e.preventDefault();
  $(this).parent().siblings().removeClass("active");
  $(this).parent().toggleClass("active");
});

$("[data-foot-cta]").on("click", function (e) {
  e.preventDefault();
  $(this).parents(".f-col").siblings().removeClass("active");
  $(this).parents(".f-col").toggleClass("active");
});

let _root = $("body");

let _mobile_menu = $("[data-mobile-menu]");
if (_mobile_menu.length) {
  //$('body').append(_mobile_menu);
}
function mobile_height() {
  let _mobile_menu = $("[data-mobile-menu]");
  let _root_height = $(window).height();
  let _header_height = $(".main-header").innerHeight();
  if (_mobile_menu.length) {
    _mobile_menu.css("max-height", _root_height - _header_height);
  }
}
mobile_height();
$(window).on("resize touchmove", mobile_height);

$(document).on("click", "[data-menu-toggle]", function () {
  $("[data-menu-toggle]").toggleClass("open");
  setTimeout(function () {
    $(window).trigger("resize");
  }, 700);
  if (_mega_menu.length) {
    $("[data-mega-menu], [data-mobile-menu]").toggleClass("opened");
    clearMegaTab();
  }
  _root.toggleClass("overflow-hidden menu-opened");
  $(".main-header").toggleClass("menu-opened");
  if ($(".fp-enabled").length) {
    if (!_root.hasClass("overflow-hidden")) {
      fullpage_api.reBuild();
    }
  }
});

_mega_link.on("click", function (e) {
  e.preventDefault();
  let that = $(this);
  let data_id = that.attr("data-mega-link");
  let data_sub = $('[data-mega-sub="' + data_id + '"]');
  clearMegaTab();
  _mega_link.not(that).removeClass("active");
  if (_mega_sub.length && data_id) {
    _mega_sub.not(data_sub).removeClass("opened");
  }
  if (_win_desktop) {
    that.addClass("active");
    data_sub.addClass("opened");
  } else {
    that.toggleClass("active");
    if (_mega_sub.length && data_id) {
      data_sub.toggleClass("opened");
    }
  }
});

let _mega_tab = $("[data-mega-tab]");
let _mega_tab_content = $("[data-mega-tab-content]");

if (_mega_tab.length) {
  _mega_tab.each(function (i) {
    let that = $(this);
    that.attr("data-mega-tab", i);
  });
}
if (_mega_tab_content.length) {
  _mega_tab_content.each(function (i) {
    let that = $(this);
    that.attr("data-mega-tab-content", i);
  });
}
_mega_tab.on("click", function (e) {
  e.preventDefault();
  let that = $(this);
  let data_id = that.attr("data-mega-tab");
  _mega_tab.removeClass("active");
  that.addClass("active");
  if (_mega_tab_content.length) {
    _mega_tab_content.removeClass("opened");
  }
  if (data_id) {
    $('[data-mega-tab-content="' + data_id + '"]').addClass("opened");
  }
});

_root_all = $("html, body");

// Blog Filters
let _filters_col = $("[data-cols]");
let _filters_refine_link = $("[data-filters-refine]");
let _filters_modal = $("[data-filters-modal]");
let _filters_close_link = $("[data-filters-close]");
let _filters_overlay = '<div class="filters-overlay" />';

if (_filters_col.length) {
  _filters_col.each(function () {
    if ($(this).find("li").length <= 3) {
      $(this).addClass("one-col");
    }
  });
}
_filters_refine_link.on("click", function (e) {
  e.preventDefault();
  _filters_modal.addClass("opened");
  _root.addClass("overflow-hidden filters-opened");
  $(_filters_overlay).insertBefore(_filters_modal);
});
_filters_close_link.on("click", function (e) {
  e.preventDefault();
  _filters_modal.removeClass("opened");
  _root.removeClass("overflow-hidden filters-opened");
  $(".filters-overlay").remove();
});

// Sticky sidebar (Blog Page)
let _win = $(window);
let _sticky_sidebar = $("[data-blog-sidebar]");
let _blog_content = $(".recent-news-author");
function sticky_relocate(sticky) {
  let _sticky_box = $(sticky);

  if (_sticky_box.length) {
    _sticky_box.css({
      left: _sticky_box.parent().offset().left + 18,
      //'top' : _sticky_box.parent().offset().top
    });
  }
}
function stickyStop() {
  if (_blog_content.length && _sticky_sidebar.length) {
    if (offsetBottom(".single-post-content") < 330) {
      _sticky_sidebar.addClass("stopped");
    } else {
      _sticky_sidebar.removeClass("stopped");
    }
  }
}
stickyStop();
if (_sticky_sidebar.length) {
  sticky_relocate("[data-blog-sidebar]");
}
_win.on("scroll", function () {
  if (_sticky_sidebar.length) {
    if (_win.scrollTop() > offsetTop("[data-blog-sidebar]") + 100) {
      _sticky_sidebar.addClass("sticky");
    } else {
      _sticky_sidebar.removeClass("sticky");
    }
  }
});

_win.on("resize", function () {
  sticky_relocate("[data-blog-sidebar]");
});
_win.on("resize scroll", function () {
  stickyStop();
});

// Reading progress bar
let _progress_bar = $("[data-progress-bar]");

function progressPosition() {
  if (_progress_bar.length) {
    if ($(window).scrollTop() > 500) {
      $(".progress-bar-wrap").addClass("sticky-top");
      setTimeout(function () {
        $(".progress-bar-wrap").addClass("visible");
      }, 300);
    } else {
      $(".progress-bar-wrap").removeClass("sticky-top visible");
    }
  }
}
progressPosition();
$(window).on("scroll", function () {
  progressPosition();
});
let _progress_content = $(".single-post-content");
if (_progress_bar.length && _progress_content.length) {
  let getMax = function () {
    //return $(document).height() - $(window).height();
    return _progress_content.height();
  };

  let getValue = function () {
    return $(window).scrollTop();
  };

  if ("max" in document.createElement("progress")) {
    // Browser supports progress element
    let _progressBar = $("progress");

    // Set the Max attr for the first time
    _progressBar.attr({ max: getMax() });

    $(document).on("scroll", function () {
      // On scroll only Value attr needs to be calculated
      _progressBar.attr({ value: getValue() });
    });

    $(window).resize(function () {
      // On resize, both Max/Value attr needs to be calculated
      _progressBar.attr({ max: getMax(), value: getValue() });
    });
  } else {
    let _progressBar = $(".progress-bar"),
      max = getMax(),
      value,
      width;

    let getWidth = function () {
      // Calculate width in percentage
      value = getValue();
      width = (value / max) * 100;
      width = width + "%";
      return width;
    };

    let setWidth = function () {
      progressBar.css({ width: getWidth() });
    };

    $(document).on("scroll", setWidth);
    $(window).on("resize", function () {
      // Need to reset the Max attr
      max = getMax();
      setWidth();
    });
  }
}

// Reading Blog (Remaining time)

function read_time() {
  let _read_time_box = $("[data-read-time]");
  if (_read_time_box.length) {
    let _read_time_value = _read_time_box.data("read-time");
    let _progress = $(window).scrollTop() / ($(document).height() - _progress_content.height());
    let _progress_time = _read_time_value - _read_time_value * _progress;
    let _text = Math.ceil(_progress_time);
    //_read_time_box.toggleClass('anim', 150)
    if (_progress_time <= 0.5) {
      _read_time_box.text(0);
    } else {
      _read_time_box.text(_text);
    }
  }
}
read_time();

_win.on("scroll", read_time);

function leftpartHeight() {
  setTimeout(function () {
    var navHeight = $(".hm-navigation .container-fluid").innerHeight();
    var navHeightHeader = $(".hm-navigation header").innerHeight();
    $(".leftpart").css({ height: navHeight + navHeightHeader });
  }, 200);
}

leftpartHeight();

// Get bottom el position
function offsetBottom(el, i) {
  i = i || 0;
  return $(el)[i].getBoundingClientRect().bottom;
}

// Get top el position
function offsetTop(el, i) {
  i = i || 0;
  return $(el)[i].getBoundingClientRect().top;
}

$(window).on("load", function () {
  setbg();
  var wh = $(window).height();
  try {
    var isPhoneDevice = "ontouchstart" in document.documentElement;
  } catch (err) {}

  var textWrapper = document.querySelector(".animate-text");
  if (textWrapper !== null) {
    textWrapper.style.visibility = "hidden";
  }

  var circle_box = ".circlebx";
  var letter_anime = ".animate-text";

  if ($(circle_box).length) {
    $(circle_box).appear();
  }
  if (circle_box.length) {
    $(letter_anime).appear();
  }

  // Start Circle animation
  $(document.body).on("appear", circle_box, function (e, $affected) {
    if (!$(circle_box).hasClass("appeared")) {
      var circleboxanim = new TimelineMax({ paused: true });
      circleboxanim.fromTo(".circlebox svg", 2, { rotation: 0, z: 0.01, scale: 0.98 }, { rotation: 360, z: 0.01, scale: 0.98 }, 0);
      circleboxanim.from(".circlebox svg", 1.5, { scale: 1, repeat: -1, ease: Power0.easeNone });
      setTimeout(function () {
        $(".linecolor[data-name='pm']").trigger("click");
      }, 300);
      $(".circle_tab_content").hide();
    }
    $(circle_box).addClass("appeared");
  });

  // Start Letters animation https://animejs.com/
  $(document.body).on("appear", letter_anime, function (e, $affected) {
    if (textWrapper !== null) {
      setTimeout(function () {
        textWrapper.style.visibility = "visible";
      }, 100);
      setTextAnime();
    }
  });

  let _play_video = $("[data-play-video]");
  _play_video.on("click", function (e) {
    e.preventDefault();
    let that = $(this);
    if (that.hasClass("is-pause")) {
      that.removeClass("is-pause").closest(".has-controls").removeClass("video-play").find("video").prop({ controls: false, muted: true }).trigger("pause");
    } else {
      that.addClass("is-pause").closest(".has-controls").addClass("video-play").find("video").prop({ controls: true, muted: false }).trigger("play");
    }
    that
      .parent()
      .find("video")
      .on("ended", function () {
        that.removeClass("is-pause");
        that.closest(".has-controls").removeClass("video-play");
        that.closest(".has-controls").find("video").prop({ controls: false, muted: true });
      });
    that
      .parent()
      .find("video")
      .on("pause", function () {
        that.removeClass("is-pause");
        that.closest(".has-controls").removeClass("video-play");
        that.closest(".has-controls").find("video").prop({ controls: false, muted: true });
      });
  });

  wow = new WOW({
    offset: 300,
  });

  wow.init();

  $(window).scroll(function () {
//     if ($(window).scrollTop() >= wh * 2.8) {
//       $("nav").addClass("fixed-header-");
//     } else {
//       $("nav").removeClass("fixed-header-");
//     }
  });

  var _feature_steps = $("[data-feature-steps]");
  function stepsHeight() {
    if (_feature_steps.length) {
      _feature_steps.each(function () {
        var that = $(this);
        var _step = that.children();
        var _h_last_step = _step.last().innerHeight();
        var _h_steps = that.innerHeight();
        that.css("min-height", _h_steps - _h_last_step - 1);
      });
    }
  }
  function stepsSlider() {
    if (_feature_steps.length) {
      _feature_steps.each(function () {
        var that = $(this);

        if (window.matchMedia("(min-width: 768px)").matches) {
          if (that.hasClass("owl-builded")) {
            that.trigger("destroy.owl.carousel");
            that.removeClass("owl-builded");
          }
        } else {
          that.owlCarousel({
            nav: true,
            items: 1,
            dots: false,
            smartSpeed: 700,
            //autoHeight: true
          });
          that.addClass("owl-builded");
        }
      });
    }
  }
  let _study_slider = $(".js-study-slider");
  function studySlider() {
    if (_study_slider.length) {
      _study_slider.each(function () {
        var that = $(this);

        if (window.matchMedia("(min-width: 768px)").matches) {
          if (that.hasClass("owl-builded")) {
            that.trigger("destroy.owl.carousel");
            that.removeClass("owl-builded");
          }
        } else {
          that.owlCarousel({
            nav: true,
            items: 1,
            dots: false,
            smartSpeed: 700,
            //autoHeight: true
          });
          that.addClass("owl-builded");
        }
      });
    }
  }
  stepsSlider();
  studySlider();
  stepsHeight();
  $(window).on("resize", function () {
    stepsSlider();
    studySlider();
    stepsHeight();
  });
});

$("document").ready(function ($) {
  function videoStart() {
    let _video_start = $("[data-play-video]");
    if (_video_start.length) {
      _video_start.each(function (i) {
        var video = $(this);
        video.attr("id", "video_" + i);
        var video_play = document.getElementById("video_" + i);
        setTimeout(function () {
          var playPromise = video_play.play();
          console.log(video_play);
          if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
          }
        }, 300);
      });
    }
  }

  videoStart();

  $(".figure-kd").each(function () {
    let tl = new TimelineMax();
    const secondaryTitle = $(this).find(".figure-img, .figure-caption");
    tl.to(secondaryTitle, 1, { opacity: 0.5, y: "-50px" }, "-+1.1");
    let scene = new ScrollMagic.Scene({
      triggerElement: this,
      duration: 500,
      offset: 0,
      triggerHook: 0.2,
    })
      .setTween(tl)
      .addTo(controller);
  });

  var _desktop_view = $(window).width() > 768;
  var _root = $("html");
  var _cs_section = $(".cs-section");

  if (_cs_section.length) {
    new fullpage("#fullpage", {
      navigation: true,
      navigationPosition: "right",
      autoScrolling: true,
      scrollBar: true,
      scrollingSpeed: 700,
      //paddingTop: '87px',
      normalScrollElements: "[data-mega-scroll], [data-mega-menu], [data-hire-modal], .acsb-main",
      onLeave: function (origin, destination, direction) {
        if (direction == "down") {
          $(".main-header").addClass("normal-header");
        }
        if (direction == "up" && destination.index !== 0) {
          setTimeout(function () {
            $(".main-header").removeClass("normal-header");
          }, 300);
          setTimeout(function () {
            $(".main-header").addClass("normal-header");
          }, 3000);
        }
        if (direction == "up" && destination.index == 0) {
          $(".main-header").removeClass("normal-header");
        }
      },
    });
  }

  var _full_page_simple = $(".fullpage-simple");
  var _full_section = _full_page_simple.find(".section");
  if (_desktop_view) {
    if (_full_page_simple.length && _full_section.length > 1) {
      new fullpage("#fullpage", {
        autoScrolling: true,
        scrollBar: true,
        scrollingSpeed: 700,
        navigation: true,
        navigationPosition: "right",
        //paddingTop: '87px',
        //scrollOverflow: true,
        normalScrollElements: ".normal-scroll, [data-mega-scroll], [data-mega-menu], [data-hire-modal], .acsb-main",
        onLeave: function (origin, destination, direction) {
          console.log(destination.index)
          if ( destination.index !== 0) {
          	$(".main-header").addClass("fixed-header");
          }
          if ( destination.index == 0) {
            $(".main-header").removeClass("normal-header");
          }                    
          
          if (direction == "down") {
            $(".main-header").addClass("normal-header");
          }
          if (direction == "up" && destination.index !== 0) {
            setTimeout(function () {
              $(".main-header").removeClass("normal-header");
            }, 300);
            setTimeout(function () {
              $(".main-header").addClass("normal-header");
            }, 3000);
          }
          if (direction == "up" && destination.index == 0) {
            $(".main-header").removeClass("normal-header");
            $(".main-header").removeClass("fixed-header");
            setTimeout(function () { $(".main-header").removeClass("normal-header"); }, 1000);            
            setTimeout(function () { $(".main-header").removeClass("normal-header"); }, 2000);            
            setTimeout(function () { $(".main-header").removeClass("normal-header"); }, 3000);            
          }
        },
      });
    }
  }

  var controller = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 0,
    },
  });

  var _full_page_home = $(".home-page");
  var _circle_section = $("[data-circle-box]");
  var _header = $(".main-header");
  var _scroll_auto = true;
  var _scroll_bar = true;
  if (_win.innerWidth() < 768) {
    //_scroll_auto = false
  }
  if (_desktop_view) {  
    if (_full_page_home.length) {
      new fullpage("#fullpage", {
        navigation: true,
        navigationPosition: "left",
        autoScrolling: _scroll_auto,
        scrollBar: true,
        scrollingSpeed: 700,
        //scrollOverflow: true,
        // hybrid: true,
        fitToSection: false,
        normalScrollElements: "#recent-news_, [data-mega-scroll], [data-hire-modal], [data-mega-menu], .acsb-main",
        afterReBuild: function () {
          console.log("fullPage.js has manually being re-builded");
        },
        onLeave: function (origin, destination, direction) {
          console.log("index", destination.index);
          $(".main-header").addClass("fixed-header");
          if (destination.index > 0) {
            _root.addClass("hero-unpin");
            setTimeout(function () {
              $(".main-header").addClass("fixed-header");
            }, 400);
          }
          if (destination.index <= 0) {
            _root.removeClass("hero-unpin");
            setTimeout(function () {
              $(".main-header").removeClass("fixed-header");
            }, 400);
          }
          // define movement of panels .pm - blue, .dd - green, .vp - yellow
          if (destination.index == 1 && direction == "down") {
            setTimeout(function () {
              if (_circle_section.length) {
                _circle_section.addClass("start-animated");
              }
            }, 400);
          }
          if (destination.index >= 3 && destination.index <= 5) {
            setTimeout(function () {
              if (_circle_section.length) {
                _circle_section.addClass("stopped animated");
              }
            }, 450);
          } else {
            setTimeout(function () {
              if (_circle_section.length) {
                _circle_section.removeClass("stopped");
              }
            }, 400);
          }
          if (destination.index == 3) {
            _circle_section.removeClass("dd-active vp-active").addClass("pm-active");
          }
          if (destination.index == 4) {
            _circle_section.removeClass("pm-active vp-active").addClass("dd-active");
          }
          if (destination.index == 5) {
            _circle_section.removeClass("pm-active dd-active").addClass("vp-active");
          }
          if (destination.index > 0 && direction == "down") {
            $(".main-header").addClass("normal-header");
          }
          if (destination.index !== 0 && direction == "up") {
            setTimeout(function () {
              $(".main-header").removeClass("normal-header");
            }, 300);
            setTimeout(function () {
              if (destination.index !== 0) {
              	$(".main-header").addClass("normal-header");
              }
            }, 3000);
          }
          if (direction == "up" && destination.index == 0) {
            $(".main-header").removeClass("normal-header");
          }
        },
      });
      function setNav() {
        let _toggle_left = $("[data-menu-toggle]").offset().left;
        $("#fp-nav").css("right", _toggle_left);
      }
      setNav();
      $(window).on("resize", setNav);
    }
  }
});

window.onload = function () {
  let _preloader = $("[data-preloader]");
  setTimeout(function () {
    if (_preloader.length) {
      _preloader.hide();
    }
  }, 500);
  $("[data-preload]").attr("data-preload", false);
};

function stickyHeader() {
//   var check_front = $('body[class*="front"]').length;
//   if (!check_front) {
//     if ($(window).scrollTop() > 500) {
//       $(".main-header").addClass("fixed-header");
//       setTimeout(function () {
//         $(".main-header").addClass("full-header");
//       }, 300);
//     } else {
//       $(".main-header").removeClass("fixed-header full-header");
//     }
//   }
}
stickyHeader();
$(window).scroll(function () {
  stickyHeader();
});

     
function closeActiveHosted(){
	$(".wrap-form-activehosted").hide();
}     

function playPause(){var t=document.getElementsByTagName("video")[0];var e=document.getElementsByClassName("watchButton");for(var a=0;a<e.length;a++)e[a].style.visibility="hidden";t.paused&&t.play();var n=document.createElement("style");n.type="text/css",n.innerHTML="video::-webkit-media-controls-start-playback-button {display: block;}",document.body.appendChild(n)}

$('html').bind('mousewheel DOMMouseScroll', function (e) {
  setTimeout(function () {
        
    if ($('.active').find('.watchButtonContainer a').attr('aria-describedby')){
      console.log('2')
      playPause();
    }      
  }, 10);                 

});